import { IconButton, Pagination } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { DataGrid, GridToolbarColumnsButton } from "@mui/x-data-grid";
import { useCallback, useEffect, useState } from "react";
import {
	getPermissionData,
	getUserData,
} from "../../Actions/common";
import {
	deleteSingleMultipleBusinessAction,
	getAllWhiteListIpsAction,
	getWhitelistIpByIdAction,
} from "../../Actions/whiteListpsAction";
import { DataGrid_SX } from "../../Assets/customTheme/constants";
import { CustomNoRowsOverlay } from "../../Assets/customTheme/CustomNoRowsOverlay";
import {
	default as CoustomTooltip,
	default as CustomTooltip,
} from "../../Assets/customTheme/customtooltip";
import {
	MyAddRoundedIcon,
	MyDeleteOutlineOutlinedIcon,
	MyEditOutlinedIcon,
	MySearchIcon,
} from "../../Assets/svg/MyIcons";
import { TableColumns, TableFilte, TableReset } from "../../Assets/svg/svgicon";
import BreadcrumbsComponent from "../../components/Common/Breadcrumbs";
import {  ITEMS_PER_PAGE_OPTIONS } from "../../config";
import CustomSnackbar from "../Common/snackBar";
import AddEditWhiteListIp from "./AddEditWhiteListIp";
import showConfirmation from "../../utils/Conformation";
import { CommonTooltip } from "../../utils/tooltip";

const CustomToolbar = ({
	selectedRows,
	handleDeleteSelected,
	searchValue,
	handleSearchApi,
	handleFilterData,
	handleResetFilters,
	hasPermission,
	filterButtonDisabled,
	resetButtonDisabled,
	handleAddIp,
}) => {
	return (
		<div className="custom-header ">
			<div className="card border-rounded-0 fiter-card">
				<div className="card-body p-5 pb-0">
					<div className="row">
						<div className="col-xl-3 col-xxl-2 col-lg-3 col-md-4 col-sm-6  mb-5">
							<div className="input-group w-100">
								<div className="input-group-prepend">
									<span
										className="input-group-text"
										id="basic-addon1"
									>
										{" "}
										<MySearchIcon />
									</span>
								</div>
								<input
									type="text"
									data-kt-table-widget-4="search"
									className="form-control"
									placeholder="Search"
									name="search"
									value={searchValue}
									onChange={handleSearchApi}
								/>
							</div>
						</div>
						<div className="col-auto ms-auto d-flex flex-wrap gap-3 mb-5">
							<CustomTooltip title="Filter" placement="top" arrow>
								<span>
								<button
									className="btn text-primary btn-light btn-icon"
									onClick={handleFilterData}
									disabled={filterButtonDisabled}
								>
									<TableFilte />
								</button>
								</span>
							</CustomTooltip>
							<CustomTooltip title="Reset" placement="top" arrow>
								<span>
								<button
									className="btn text-primary btn-light btn-icon"
									onClick={handleResetFilters}
									disabled={resetButtonDisabled}
								>
									<TableReset />
								</button>
								</span>
							</CustomTooltip>

							<CoustomTooltip
								title="Column Filter"
								placement="top"
								arrow
							>
								<span style={{ display: "inline-block" }}>
									<GridToolbarColumnsButton
										slotProps={{
											tooltip: { title: "" },
											button: {
												className:
													"btn btn-light text-primary btn-icon grid-toolbar d-flex justify-content-center align-items-center p-0",
												style: {
													width: "47px",
													height: "44px",
													minWidth: "unset",
													borderRadius: "8px",
												},
												startIcon: <TableColumns />,
											},
										}}
									/>
								</span>
							</CoustomTooltip>

							{selectedRows.length !== 0 && (
								<CoustomTooltip
									title="Delete"
									placement="top"
									arrow
								>
									<span>
										<button
											className="btn btn-outline-danger  btn-icon btn-outline "
											onClick={handleDeleteSelected}
											disabled={selectedRows.length === 0}
										>
											<MyDeleteOutlineOutlinedIcon />
										</button>
									</span>
								</CoustomTooltip>
							)}
							{hasPermission?.canCreate && (
								<button
									className="btn btn-outline btn-primary btn-add"
									onClick={(e) => handleAddIp(e)}
								>
									<MyAddRoundedIcon className="me-1 text-white" />{" "}
									ADD
								</button>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const Whitelist = ({ merchantId }) => {
	const [filterButtonDisabled, setFilterButtonDisabled] = useState(true);
	const [resetButtonDisabled, setResetButtonDisabled] = useState(true);
	const [totalRecords, setTotalRecords] = useState(0);
	const [searchValue, setSearchValue] = useState("");
	const [loading, setLoading] = useState(true);
	const [snackbar, setSnackbar] = useState({
		open: false,
		message: "",
		severity: "success",
	});
	const [selectedRows, setSelectedRows] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const [shouldFetchData, setShouldFetchData] = useState(1);
	const [ipDataById, setIpDataById] = useState(null);
	const [whiteListIpsData, setWhiteListIpsData] = useState([]);
	const [anchorEl, setAnchorEl] = useState(null);
	const isMenuOpen = Boolean(anchorEl);
	const [selectedRowsPerPage, setSelectedRowsPerPage] = useState(
		ITEMS_PER_PAGE_OPTIONS[0]
	);

	const [openModal, setOpenModal] = useState(false);

	const userData = localStorage.getItem("userData") ? getUserData() : null;
	const permissionData = localStorage.getItem(
		`${userData?.id}_permissionData`
	)
		? getPermissionData(`${userData?.id}_permissionData`)
		: [];
	const hasPermission = permissionData[0]?.role_permissions?.find(
		(m) => m?.module && m?.module?.slug === "ip-whitelist"
	);

	const getWhiteListIps = useCallback(async () => {
		setLoading(true);
		await getAllWhiteListIpsAction(
			currentPage,
			searchValue,
			selectedRowsPerPage,
			null,
			null,
			merchantId ?? undefined
		)
			.then((res) => {
				const { rows, count } = res.data.data;
				if (res?.data.status === 202) {
					setSnackbar({
						open: true,
						message: res?.data?.message,
						severity: "info",
					});
					return;
				}
				setWhiteListIpsData(rows);
				setTotalRecords(count);
				setLoading(false);
			})
			.catch((error) => {
				setSnackbar({
					open: true,
					message: error.response.data.message,
					severity: "error",
				});
			});
		setLoading(false);
	}, [currentPage, searchValue, selectedRowsPerPage, merchantId]);

	useEffect(() => {
		if (shouldFetchData) {
			getWhiteListIps();
			setShouldFetchData(0);
		}
	}, [shouldFetchData, getWhiteListIps]);

	const handleCloseSnackbar = () => {
		setSnackbar({ ...snackbar, open: false });
	};

	const handleMenuClose = () => {
		setAnchorEl(null);
	};

	const handleDelete = async (e, row) => {
		e.stopPropagation();

		await showConfirmation("simpleDelete", {
			entityName: "Merchant",
			entityId: row,
			action: deleteSingleMultipleBusinessAction,
			onSuccess: (res) => {
				getWhiteListIps();
			},
			onError: (error) => {
				setSnackbar({
					open: true,
					message: error?.response?.data?.message || "Something went wrong",
					severity: "error",
				});
			},
			showCancelledMsg: true,
		});
	};

	const handleSearchApi = (e) => {
		const inputValue = e.target.value.trim();
		if (inputValue.length === 0) {
			setFilterButtonDisabled(true);
		} else {
			setFilterButtonDisabled(false);
		}
		setSearchValue(inputValue);
	};

	// const handleRowSelection = (event, ele) => {
	// 	const selectedId = ele.id;
	// 	if (event.target.checked) {
	// 		// Add the selected ID to the array
	// 		setSelectedRows((prevSelectedRows) => [
	// 			...prevSelectedRows,
	// 			selectedId,
	// 		]);
	// 	} else {
	// 		setSelectedRows((prevSelectedRows) =>
	// 			prevSelectedRows.filter((id) => id !== selectedId)
	// 		);
	// 	}
	// };

	// const handleSelectAll = (event) => {
	// 	if (event.target.checked) {
	// 		const allIds = whiteListIpsData.map((ele) => ele.id);
	// 		setSelectedRows(allIds);
	// 	} else {
	// 		setSelectedRows([]);
	// 	}
	// };

	const handleDeleteSelected = async () => {
		if (selectedRows.length === 0) return;

		const result = await showConfirmation("simpleMultipleDelete", {
			entityName: "Merchant",
			entityIds: selectedRows,
			action: async (ids) => {
				// Your API expects { ids: [...] } format
				return await deleteSingleMultipleBusinessAction({ ids });
			},
			onSuccess: (res) => {
				setSelectedRows([]);
				setCurrentPage(1);
				getWhiteListIps();
			},
			onError: (error) => {
				setSnackbar({
					open: true,
					message: error?.response?.data?.message || "Something went wrong",
					severity: "error",
				});
				setSelectedRows([]);
			},
			showCancelledMsg: true,
		});

		if (result?.cancelled) {
			setSelectedRows([]);
		}
	};

	const handlePaginationChange = (event, value) => {
		setSelectedRows([]);
		setCurrentPage(value);
		setShouldFetchData(1);
	};

	const handleResetFilters = () => {
		setSearchValue("");
		setCurrentPage(1);
		setShouldFetchData(1);
		setResetButtonDisabled(true);
		setFilterButtonDisabled(true);
	};

	const handleFilterData = () => {
		setLoading(true);
		setCurrentPage(1);
		setShouldFetchData(1);
		setLoading(false);
		setFilterButtonDisabled(true);
		setResetButtonDisabled(false);
	};

	const handleRowsPerPageChange = (event) => {
		setWhiteListIpsData([]);
		setSelectedRows([]);
		const newValue = parseInt(event.target.value);
		setSelectedRowsPerPage(newValue);
		setCurrentPage(1);
		setLoading(true);
		setShouldFetchData(1);
	};

	const handleAddIp = async (e, row) => {
		if (row) {
			await getWhitelistIpByIdAction(row)
				.then((res) => {
					setIpDataById(res.data);
					setOpenModal(true);
				})
				.catch((error) => {
					setSnackbar({
						open: true,
						message: error?.response?.data?.message,
						severity: "error",
					});
				});
		} else {
			setOpenModal(true);
		}
	};

	const handleCloseModal = () => {
		setOpenModal(false);
		setIpDataById(null);
	};

	const columns = [
		// {
		// 	field: "id",
		// 	minWidth: 60,
		// 	width: 60,
		// 	headerName: "",
		// 	sortable: false,
		// 	filterable: false,
		// 	disableColumnMenu: true,
		// 	renderHeader: (params) => (
		// 		<Checkbox
		// 			onChange={handleSelectAll}
		// 			disabled={
		// 				!whiteListIpsData || whiteListIpsData.length === 0
		// 			}
		// 			checked={
		// 				whiteListIpsData &&
		// 				whiteListIpsData.length > 0 &&
		// 				selectedRows.length === whiteListIpsData.length
		// 			}
		// 			sx={MyCheckboxIcon}
		// 		/>
		// 	),
		// 	renderCell: (params) => (
		// 		<Checkbox
		// 			onChange={(event) => handleRowSelection(event, params.row)}
		// 			checked={selectedRows.includes(params.row.id)} // Use the array to check if the id is selected
		// 			sx={MyCheckboxIcon}
		// 		/>
		// 	),
		// },
		{
			field: "ipAddress",
			minWidth: 150,
			headerName: "Ip Address",
			flex: 1,
		},
		...(hasPermission?.canEdit || hasPermission?.canDelete
        	? [
				{
					field: "actions",
					headerName: "Action",
					sortable: false,
					minWidth: 120,

					renderCell: (params) => (
						<>
							{hasPermission?.canEdit && (
								<CommonTooltip title="Edit" placement="top" arrow>
									<IconButton
										className="btn-custom-i text-primary me-3"
										onClick={(e) => handleAddIp(e, params.row.id)}
									>
										<MyEditOutlinedIcon />
									</IconButton>
								</CommonTooltip>
							)}
							{hasPermission?.canDelete && (
								<CommonTooltip title="Delete" placement="top" arrow>
									<IconButton
										className="btn-custom-i text-primary"
										onClick={(e) => handleDelete(e, params.row.id)}
									>
										<MyDeleteOutlineOutlinedIcon />
									</IconButton>
								</CommonTooltip>
							)}
						</>
					),
				},
			]
      : []),
	];

	return (
		<div id="kt_content_container">
			<BreadcrumbsComponent />

			<DataGrid
				className="border-0"
				localeText={{ toolbarColumns: "" }}
				rows={whiteListIpsData}
				columns={columns}
				autoHeight
				hideFooterRowCount={true}
				hideFooterPagination={true}
				hideFooter={true}
				loading={loading}
				slots={{
					toolbar: CustomToolbar,
					noRowsOverlay: CustomNoRowsOverlay,
				}}
				slotProps={{
					toolbar: {
						selectedRows,
						handleDeleteSelected,
						searchValue,
						handleSearchApi,
						handleFilterData,
						handleResetFilters,
						hasPermission,
						whiteListIpsData,
						isMenuOpen,
						anchorEl,
						handleMenuClose,
						filterButtonDisabled,
						resetButtonDisabled,
						handleAddIp,
					},
				}}
				sx={DataGrid_SX}
			/>
			<div className="card-footer d-flex align-items-center justify-content-between mt-7">
				<div className="d-flex align-items-center">
					<label className="fw-semibold me-3">
						{"Row per page"}{" "}
					</label>
					<FormControl
						variant="standard"
						style={{
							minWidth: 50,
						}}
					>
						<Select
							labelId="rows-per-page-label"
							id="rows-per-page"
							value={selectedRowsPerPage}
							onChange={handleRowsPerPageChange}
							label="Row per page"
						>
							{ITEMS_PER_PAGE_OPTIONS?.map((option) => (
								<MenuItem key={option} value={option}>
									{option}
								</MenuItem>
							))}
						</Select>
					</FormControl>
				</div>
				{!loading && whiteListIpsData?.length > 0 ? (
					<Pagination
						count={Math.ceil(totalRecords / selectedRowsPerPage)}
						page={currentPage}
						onChange={(event, value) =>
							value !== currentPage
								? handlePaginationChange(event, value)
								: null
						}
						variant="outlined"
						shape="rounded"
						className="custom-pagination"
					/>
				) : null}
			</div>
			{openModal ? (
				<AddEditWhiteListIp
					getIpData={whiteListIpsData}
					open={openModal}
					handleClose={handleCloseModal}
					ipDataById={ipDataById}
					setSnackbar={setSnackbar}
					getWhiteListIps={getWhiteListIps}
				/>
			) : null}

			<CustomSnackbar
				open={snackbar.open}
				message={snackbar.message}
				severity={snackbar.severity}
				onClose={handleCloseSnackbar}
			/>
		</div>
	);
};

export default Whitelist;
